import React, { useEffect, useState } from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import ReactModal from "react-modal";
import {
  Approve_communnity,
  Community_List,
  Reject_community,
  Request_Community_List,
} from "../../../actions/auth";
import { useDispatch } from "react-redux";
import { MY_PROFILE, MY_PROFILE_COMMUNITY } from "../../../actions/types";
import moment from "moment";
import Pagination from "react-js-pagination";
import DatePicker from "react-date-picker";
import swal from "sweetalert";

const RequestedCommunity = () => {
  const [loading, setLoading] = useState(false);
  const [loadingData, setLoadingData] = useState(false);
  const [List, setList] = useState("");
  const [activePage, setActivePage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [total, setTotal] = useState("");
  const [searchData, setSearchData] = useState("");
  const [sortOrder, setSortOrder] = useState(""); // 'asc' or 'desc'
  const [sortField, setSortField] = useState(""); // 'asc' or 'desc'

  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [accept, setAccept] = useState("");
  const [dateError, setDateError] = useState(""); // To show validation error message
  const [AcceptReq, setReq] = useState(false); // To show validation error message

  const dispatch = useDispatch();

  const formatDate = (date) => {
    if (!date) return ""; // Handle null or undefined dates
    const d = new Date(date);
    const month = String(d.getMonth() + 1).padStart(2, "0"); // Get month and pad with leading zero
    const day = String(d.getDate()).padStart(2, "0"); // Get day and pad with leading zero
    const year = d.getFullYear(); // Get year
    return `${month}-${day}-${year}`; // Format as MM-DD-YYYY
  };

  useEffect(() => {
    setLoadingData(true);
    dispatch(
      Request_Community_List(
        activePage,
        itemsPerPage,
        searchData ? searchData : " ",
        sortOrder || "",
        sortField || "",
        formatDate(fromDate || ""), // Format the fromDate
        formatDate(toDate || "")
      )
    ).then((response) => {
      console.log(response, "Community_List");
      if (response.success == true) {
        setTotal(response.meta.totalCount);
        setList(response.data);
      }
    });
  }, [activePage, searchData, fromDate, toDate, total]);

  const searchList = (e) => {
    const data = e.target.value.trimStart();
    console.log(data, "mmmmmmm");
    setSearchData(data);
    setActivePage(1);
    if (data) {
      dispatch(
        Request_Community_List(
          activePage,
          itemsPerPage,
          data ? data : "",
          sortOrder || "",
          sortField || "",
          formatDate(fromDate || ""), // Format the fromDate
          formatDate(toDate || "")
        )
      ).then((response) => {
        console.log(response, "Community_List");
        if (response.success == true) {
          setTotal(response.meta.totalCount);
          setList(response.data);
        }
      });
    }
  };

  const [errorMessage, setErrorMessage] = useState("");

  const validateReason = (value) => {
    // Regex for allowed format: letters, numbers, spaces, and basic punctuation
    const validFormatRegex = /^[a-zA-Z0-9\s.,!?'"()-]*$/;

    if (!value.trim()) {
      setErrorMessage(
        "Remarks cannot be blank. Please provide a reason for rejection."
      );
      return false;
    }

    if (!validFormatRegex.test(value)) {
      setErrorMessage(
        "Invalid remarks. Only letters, numbers, spaces, and basic punctuation are allowed."
      );
      return false;
    }

    if (value.length < 2) {
      setErrorMessage("Remarks must be at least 2 characters long.");
      return false;
    }

    if (value.length > 300) {
      setErrorMessage("Remarks cannot exceed 300 characters.");
      return false;
    }

    // Clear error if all validations pass
    setErrorMessage("");
    return true;
  };

  const handleReasonChange = (e) => {
    const value = e.target.value.trimStart();
    setReason(value);

    // Validate on input change
    validateReason(value);
  };

  const handleClearSearch = () => {
    if (searchData) {
      setSearchData("");
      setLoading(true);
      dispatch(
        Community_List(activePage, itemsPerPage, "", sortOrder || "")
      ).then((response) => {
        console.log(response, "Community_List default");
        if (response.success) {
          setTotal(response.meta.totalCount);
          setList(response.data);
        }
        setLoading(false); // Stop loading
      });
    }
  };

  const calculateRange = () => {
    const currentPage = activePage;
    const itemsPerPage = 10;

    const startIndex = (currentPage - 1) * itemsPerPage + 1;

    let endIndex = currentPage * itemsPerPage;
    if (endIndex > total) {
      endIndex = total;
    }

    return `Showing ${startIndex} to ${endIndex} of ${total} entries`;
  };

  const handlePageChange = (pagenumber) => {
    if (pagenumber) {
      setLoadingData(true);
      dispatch(
        Request_Community_List(
          pagenumber,
          itemsPerPage,
          searchData ? searchData : "",
          sortOrder || "",
          sortField || "",
          formatDate(fromDate || ""), // Format the fromDate
          formatDate(toDate || "")
        )
      ).then(() => {
        setLoadingData(false); // Stop loading
      });
      setActivePage(pagenumber);
    }
  };

  const Sortt = (col) => {
    const newSortOrder = sortOrder === "asc" ? "desc" : "asc"; // Toggle sort order
    // const newSortOrder = sortOrder === "desc" ? "asc" : "desc"; // Toggle sort order

    setSortField(col);
    setSortOrder(newSortOrder);
    setLoadingData(true);
    dispatch(
      Request_Community_List(
        activePage,
        itemsPerPage,
        searchData ? searchData : "",
        newSortOrder,
        col,
        // fromDate || "",
        // toDate || ""
        formatDate(fromDate || ""), // Format the fromDate
        formatDate(toDate ? toDate : "")
      )
    ).then((response) => {
      console.log(response, "Community_List");
      if (response.success == true) {
        setTotal(response.meta.totalCount);
        setList(response.data);
      }
    });
  };

  const handleFromDateChange = (date) => {
    setFromDate(date);
    if (!toDate) {
      setDateError("Please select To Date Also.");
    } else {
      setDateError(""); // Clear error if To Date is selected
    }

    if (!fromDate) {
      setDateError(""); // If no fromDate is selected, clear the error
    } else {
      setDateError(""); // Clear error when To Date is selected
    }
    if (!date) {
      setFromDate(null);
      setToDate(null); // Reset end date when start date is removed
    }
    // if (toDate && date > toDate) {
    //   setToDate(null); // Reset toDate if it's earlier than fromDate
    // }
  };
  const handleToDateChange = (date) => {
    setToDate(date);
    setDateError(""); // Clear error when To Date is selected
    if (!fromDate) {
      setDateError(""); // If no fromDate is selected, clear the error
    } else {
      setDateError(""); // Clear error when To Date is selected
    }
  };

  // const closeModal = () => {
  //     setModalIsOpen(false);
  //     setError("");
  //     document.body.style.overflow = "auto";
  // };

  const [approveStatus, setApproveStatus] = useState("");

  const AcceptCommunity = (e) => {
    console.log(e?._id, "AcceptCommunity");
    document.body.classList.add("swal-open-modal");
    setReq(false);
    swal({
      text: `Are you sure you want to accept the community '${e?.name}'? Once accepted, users will be able to start engaging in this community.`,
      icon: "warning",
      buttons: {
        confirm: {
          text: "OK",
          value: true,
          visible: true,
          className: "",
          closeModal: true,
        },
        cancel: {
          text: "Cancel",
          value: null,
          visible: true,
          className: "",
          closeModal: true,
        },
      },
      dangerMode: true,
    }).then((willConfirm) => {
      document.body.classList.remove("swal-open-modal");
      if (willConfirm) {
        setAccept("Accepted");
        setReq(true);

        dispatch(Approve_communnity(e?._id)).then(() => {
          setApproveStatus("Approved");
          setLoadingData(true);
          dispatch(
            Request_Community_List(
              activePage,
              itemsPerPage,
              searchData ? searchData : "",
              sortOrder || "",
              sortField || "",
              formatDate(fromDate || ""), // Format the fromDate
              formatDate(toDate || "")
            )
          ).then((response) => {
            console.log(response, "Community_List");
            if (response.success == true) {
              setTotal(response.meta.totalCount);
              setList(response.data);
            }
          });
        });
      }
    });
    closeModal();
  };

  const [isOpen, setIsOpen] = useState(false);
  const [reason, setReason] = useState("");
  const [reasonER, setReasonER] = useState("");
  const [cancel_id, setCancel_id] = useState("");
  const openModal = (e) => {
    setIsOpen(true);
    setCancel_id(e);
  };

  const closeModal = () => {
    setIsOpen(false);
    setErrorMessage("");
    setReason("");
  };
  const handleReject = () => {
    if (!reason) {
      setErrorMessage(
        "Remarks cannot be blank. Please provide a reason for rejection."
      );
    }
    console.log(cancel_id?._id, "cancel_id..");
    if (reason) {
      const data = {
        rejection_reason: reason,
      };

      if (reason && !errorMessage) {
        dispatch(Reject_community(cancel_id?._id, data)).then(() => {
          setLoadingData(true);
          dispatch(
            Request_Community_List(
              activePage,
              itemsPerPage,
              searchData ? searchData : "",
              sortOrder || "",
              sortField || "",
              formatDate(fromDate || ""), // Format the fromDate
              formatDate(toDate || "")
            )
          ).then((response) => {
            console.log(response, "Community_List");
            if (response.success == true) {
              setTotal(response.meta.totalCount);
              setList(response.data);
            }
          });
        });
        closeModal();
      }
    }
  };

  return (
    <div id="wrapper">
      {" "}
      <ReactModal
        isOpen={isOpen}
        style={{
          overlay: {
            background: "rgba(0, 0, 0, .50)",
            zIndex: "999",
          },
          content: {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            marginRight: "-50%",
            transform: "translate(-50%, -50%)",
            minWidth: "570px",
            border: "none",
            padding: "0px",
            animation: "pop-up 0.5s forwards",
            overflow: "hidden",
          },
        }}
      >
        <div className="modal-header pb-3">
          <h6 className="modal-title">Reject Community Submission</h6>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={closeModal}
          ></button>
        </div>
        <div className="modal-content border-0">
          <div className="modal-body">
            <p>
              Are you sure you want to reject this community? Please provide a
              reason for rejection to notify the user.
            </p>
            <textarea
              value={reason}
              onChange={handleReasonChange}
              placeholder="Enter rejection reason..."
              maxLength={300}
              className="form-control"
              rows="5"
              style={{ width: "100%", padding: "10px" }}
            ></textarea>
            {errorMessage && <p className="text-danger mt-1">{errorMessage}</p>}
          </div>
        </div>
        <div className="modal-footer pt-3">
          <button
            onClick={closeModal}
            style={{
              padding: "10px 20px",
              background: "#ccc",
              border: "none",
              borderRadius: "5px",
            }}
          >
            Cancel
          </button>
          <button
            onClick={handleReject}
            style={{
              padding: "10px 20px",
              background: "red",
              color: "white",
              border: "none",
              borderRadius: "5px",
            }}
          >
            Reject
          </button>
        </div>
      </ReactModal>
      <style
        dangerouslySetInnerHTML={{
          __html:
            "\n\n.react-date-picker__wrapper{\nborder:0px !important;\n}\n",
        }}
      />
      <Sidebar />
      <div id="content-wrapper" className="d-flex flex-column">
        <div id="content">
          <Header />
          <div className="container-fluid">
            <div className="card shadow mb-4">
              <div className="card-header py-3">
                <h6 className="m-0 font-weight-bold text-primary">
                  Requested Communities
                </h6>
              </div>
              <div className="card-body">
                <div style={{ paddingLeft: 10, paddingRight: 10 }}>
                  <div className="row mb-2 ">
                    <div className="col-md-5">
                      <label>Search:</label>
                      <input
                        type="text"
                        className="form-control search-input-new"
                        placeholder="Enter community title to search"
                        value={searchData}
                        onChange={searchList}
                        // onKeyDown={handleSearch}
                      />
                      {searchData?.length >= 1 && (
                        <div
                          onClick={handleClearSearch}
                          // className="cross-serach-new"
                          style={{
                            position: "absolute",
                            top: "40px",
                            right: "27px",
                          }}
                        >
                          <i className="fa fa-times cursor-pointerr"></i>
                        </div>
                      )}
                    </div>

                    {console.log(fromDate, "fromDate...")}

                    <div className="col-3">
                      <label>Start Date:</label>
                      <DatePicker
                        className="form-control"
                        // selected={selectedDate}
                        value={fromDate}
                        onChange={handleFromDateChange}
                        maxDate={new Date()}
                        minDate={new Date(2015, 0, 1)}
                        onKeyDown={(e) => e.preventDefault()}
                      />
                    </div>

                    <div className="col-3">
                      <label>End Date:</label>
                      <DatePicker
                        className="form-control"
                        // selected={selectedDate}
                        value={toDate}
                        onChange={handleToDateChange}
                        minDate={fromDate}
                        disabled={!fromDate}
                        onKeyDown={(e) => e.preventDefault()}
                      />
                      {dateError && <p className="text-danger">{dateError}</p>}
                    </div>
                  </div>
                </div>
              </div>
              <div style={{ paddingLeft: 30, paddingRight: 30 }}>
                <table class="table radar-table">
                  <thead>
                    <tr>
                      <th scope="col">No. </th>
                      <th scope="col">
                        Community Title{" "}
                        <i
                          onClick={() => Sortt("name")}
                          className="fa fa-sort cursor-pointerr"
                          height="15px"
                          width="15px"
                          style={{ marginLeft: 5 }}
                        ></i>{" "}
                      </th>
                      <th scope="col">
                        Created Date{" "}
                        <i
                          onClick={() => Sortt("created_at_formatted")}
                          className="fa fa-sort cursor-pointerr"
                          height="15px"
                          width="15px"
                          style={{ marginLeft: 5 }}
                        ></i>{" "}
                      </th>

                      <th scope="col">User </th>
                      <th scope="col">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {List?.length > 0 ? (
                      List.map((e, index) => (
                        <tr key={e._id}>
                          <th scope="row">
                            {" "}
                            {(activePage - 1) * itemsPerPage + (index + 1)}
                          </th>
                          <td className="d-flex w-100">
                            <img
                              src={
                                e?.image
                                  ? MY_PROFILE_COMMUNITY + e?.image
                                  : "img/noImage.png"
                              }
                              onError={(e) => {
                                e.target.onerror = null; // Prevent infinite loop in case `noImage.png` also fails
                                e.target.src = "img/noImage.png"; // Fallback image if loading fails
                              }}
                              style={{
                                height: "50px",
                                borderRadius: "50px",
                                width: "50px",
                              }}
                            />
                            &nbsp;&nbsp;&nbsp;<p className="w-75"> {e?.name}</p>
                          </td>
                          <td>
                            {moment(e?.created_at_formatted).format(
                              "MM/DD/YYYY"
                            )}
                          </td>
                          <td>
                            <img
                              src={
                                e?.creator_details?.profile_image?.[0]
                                  ? MY_PROFILE +
                                    "/" +
                                    e?.creator_details?.profile_image[0]
                                  : "img/noImage.png"
                              }
                              onError={(imgError) => {
                                imgError.target.onerror = null; // Prevent infinite loop
                                imgError.target.src = "img/noImage.png"; // Fallback image
                              }}
                              style={{
                                height: "50px",
                                borderRadius: "50px",
                                width: "50px",
                              }}
                              alt="Creator Profile"
                            />
                            &nbsp;&nbsp;{e?.creator_details?.firstname}
                          </td>
                          <td>
                            {console.log(e, "Approved.........")}
                            {e?.is_approved === "approved" ? (
                              <span className="text-success fw-bold">
                                Approved
                              </span>
                            ) : e?.is_approved === "rejected" ? (
                              <span className="text-danger fw-bold">
                                Rejected
                              </span>
                            ) : (
                              <div className="d-flex w-max-auto">
                                <button
                                  type="button"
                                  class="btn btn-outline-success"
                                  onClick={() => AcceptCommunity(e)}
                                >
                                  Accept
                                </button>
                                <button
                                  type="button"
                                  class="ms-2 btn btn-outline-danger"
                                  onClick={() => openModal(e)}
                                >
                                  Reject
                                </button>{" "}
                              </div>
                            )}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={6}>
                          <h5 style={{ textAlign: "center" }} className="mt-3">
                            No results found
                          </h5>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
                {List && List?.length > 0 ? (
                  <div className="d-flex justify-content-between mt-3 align-items-center">
                    <ul className="mt-3 ps-0">
                      <p>{calculateRange()}</p>
                    </ul>
                    <Pagination
                      activePage={activePage}
                      itemsCountPerPage={itemsPerPage}
                      totalItemsCount={total}
                      pageRangeDisplayed={10}
                      onChange={total > itemsPerPage ? handlePageChange : null}
                      itemClass={`page-item ${
                        total <= itemsPerPage ? "noPointerrr" : ""
                      }`}
                      linkClass={
                        total && total > 0 ? "page-link" : "page-link disabled"
                      }
                    />
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RequestedCommunity;
